import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BusinessCardRoutingModule } from './business-card-routing.module';
import { Template1Component } from './template1/template1.component';
import { Template2Component } from './template2/template2.component';
import { Template3Component } from './template3/template3.component';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { SharedModule } from '@shared';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [Template1Component, Template2Component, Template3Component],
  imports: [CommonModule, BusinessCardRoutingModule, FeatherModule.pick(allIcons), SharedModule, TranslateModule],
  exports: [Template1Component, Template2Component, Template3Component],
})
export class BusinessCardModule {}
